import { VisitorType } from '@cox/core-ui8/dist/types'
import { useUdoContext } from '@cox/core-ui8/dist/UdoContext'

import AddressCapture, { ReactAddressCaptureProps } from './AddressCapture'
import AddressCaptureOutageMap from './AddressCaptureOutageMap'
import { getSpacing } from '../../utils/spacing-util'
import IsInEditorText from '../shared/IsInEditorText'

const ReactAddressCapture = (props: ReactAddressCaptureProps): JSX.Element => {
  const {
    top = false,
    right = false,
    bottom = false,
    left = false,
    lob = '',
    id = '',
    hideMCP = false,
    isInEditor = false,
    configuredFor = 'resi-prospect'
  } = props

  const { udo } = useUdoContext()
  const { visitorType } = udo
  const isLoggedIn = visitorType === VisitorType.CUSTOMER

  // Checks if hideMCP flag is true and that display is in dispatcher, not in author:
  const mcpClass = hideMCP && isInEditor === false ? 'd-none' : ''

  let RenderAddressCapture

  if (configuredFor === 'outagemap' && (!isLoggedIn || isInEditor)) {
    RenderAddressCapture = AddressCaptureOutageMap
  } else {
    RenderAddressCapture = AddressCapture
  }

  return (
    <div
      data-testid={`react-address-capture`}
      className={`react-address-capture ${getSpacing(top, right, bottom, left)} ${lob} ${mcpClass}`}
      id={id}
    >
      {IsInEditorText(isInEditor, 'React Address Capture')}
      <RenderAddressCapture {...props} />
    </div>
  )
}

export default ReactAddressCapture
